import { render } from "./questions-panel.vue?vue&type=template&id=450f62ca&scoped=true&ts=true"
import script from "./questions-panel.vue?vue&type=script&lang=ts"
export * from "./questions-panel.vue?vue&type=script&lang=ts"

import "./questions-panel.vue?vue&type=style&index=0&id=450f62ca&lang=scss&scoped=true"
import "./questions-panel.vue?vue&type=style&index=1&id=450f62ca&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450f62ca"]])

export default __exports__